import { Component } from '@angular/core';

/**
 * Generated class for the ArtIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'art-icon',
  templateUrl: 'art-icon.html'
})
export class ArtIconComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/art-icon/art-icon.ts